var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatarU = function SvgDefaultAvatarU(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "default-avatar_u_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".default-avatar_u_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.7 43.7V32.4c0-2.4.3-4.4.8-4.6 2.1-.1 3-.4 3-1.3 0-1.2-2.6-1.6-5.7-1.6-3.2 0-5.8.5-5.8 1.6 0 .9 1 1.2 3.5 1.3.7.2 1 2.2 1 4.6v11.3c0 5.3-3.7 8.5-9.2 8.5-5.2 0-8.6-2.7-8.6-8.5V32.5c0-2.4.1-4.4.6-4.6 2.2-.1 3.2-.4 3.2-1.3 0-1.2-2.4-1.6-6.3-1.6s-6.2.4-6.2 1.6c0 .9.9 1.2 3 1.3.5.2.7 2.2.7 4.6v11.4c0 8.1 5.8 11.8 12.8 11.8 8.2-.1 13.2-4.7 13.2-12z"
  })));
};
export default SvgDefaultAvatarU;